import React, { useState, useEffect, useCallback, useRef } from 'react';

// ── Componente de teste inline ──────────────────────────────────────────────

const BotTeste = ({ createApi, nomeBot }) => {
  const [msgs, setMsgs] = useState([
    { role: 'assistant', text: `Olá! Sou ${nomeBot || 'Alma'}, assistente da Allma Pilates. Estou em modo de teste — as ações reais (agendar/cancelar) funcionam normalmente. Como posso ajudar?` }
  ]);
  const [history, setHistory] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [msgs]);

  const reset = () => {
    setMsgs([{ role: 'assistant', text: `Olá! Sou ${nomeBot || 'Alma'}, assistente da Allma Pilates. Conversa reiniciada. Como posso ajudar?` }]);
    setHistory([]);
    setInput('');
  };

  const send = async () => {
    const text = input.trim();
    if (!text || loading) return;
    setInput('');
    setMsgs(p => [...p, { role: 'user', text }]);
    setLoading(true);
    try {
      const api = createApi();
      const res = await api.post('/chat', { message: text, conversationHistory: history });
      setMsgs(p => [...p, { role: 'assistant', text: res.data.reply }]);
      setHistory(res.data.history);
    } catch (err) {
      const msg = err.response?.data?.error || 'Erro ao conectar com o bot.';
      setMsgs(p => [...p, { role: 'assistant', text: `⚠️ ${msg}` }]);
    } finally {
      setLoading(false);
    }
  };

  const bubbleStyle = (role) => ({
    maxWidth: '80%',
    padding: '10px 14px',
    borderRadius: role === 'user' ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
    background: role === 'user' ? 'var(--color-primary,#0f5a30)' : 'white',
    color: role === 'user' ? 'white' : '#1e293b',
    fontSize: '0.85rem',
    lineHeight: 1.55,
    border: role === 'user' ? 'none' : '1px solid #e2e8f0',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  });

  return (
    <div style={{ borderRadius: 14, border: '1.5px solid #e2e8f0', overflow: 'hidden' }}>

      {/* Header da área de teste */}
      <div style={{ background: '#f8fafc', padding: '12px 18px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <span style={{ fontWeight: 700, fontSize: '0.9rem', color: '#0f172a' }}>🧪 Teste do Bot</span>
          <span style={{ marginLeft: 10, fontSize: '0.72rem', background: '#fef9c3', color: '#854d0e', border: '1px solid #fde68a', borderRadius: 20, padding: '2px 8px', fontWeight: 600 }}>
            Admin — usa sua sessão atual
          </span>
        </div>
        <button onClick={reset} style={{ padding: '5px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 600, color: '#64748b' }}>
          ↺ Reiniciar
        </button>
      </div>

      {/* Mensagens */}
      <div style={{ height: 320, overflowY: 'auto', padding: '16px', display: 'flex', flexDirection: 'column', gap: 10, background: '#f8fafc' }}>
        {msgs.map((m, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start' }}>
            {m.role === 'assistant' && (
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'var(--color-primary,#0f5a30)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.85rem', flexShrink: 0, marginRight: 8, alignSelf: 'flex-end' }}>🤖</div>
            )}
            <div style={bubbleStyle(m.role)}>{m.text}</div>
          </div>
        ))}
        {loading && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'var(--color-primary,#0f5a30)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.85rem', flexShrink: 0 }}>🤖</div>
            <div style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: '16px 16px 16px 4px', padding: '10px 14px', display: 'flex', gap: 5, alignItems: 'center' }}>
              {[0, 1, 2].map(j => (
                <span key={j} style={{ width: 7, height: 7, borderRadius: '50%', background: '#94a3b8', display: 'inline-block', animation: `bounce 1.2s ease-in-out ${j * 0.2}s infinite` }} />
              ))}
            </div>
          </div>
        )}
        <div ref={endRef} />
      </div>

      {/* Input */}
      <div style={{ padding: '10px 14px', background: 'white', borderTop: '1px solid #e2e8f0', display: 'flex', gap: 8 }}>
        <input
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => e.key === 'Enter' && !e.shiftKey && (e.preventDefault(), send())}
          placeholder={`Mensagem para ${nomeBot || 'Alma'}…`}
          disabled={loading}
          style={{ flex: 1, padding: '9px 12px', borderRadius: 10, border: '1.5px solid #e2e8f0', fontSize: '0.85rem', outline: 'none', background: loading ? '#f8fafc' : 'white' }}
        />
        <button onClick={send} disabled={loading || !input.trim()} style={{
          padding: '9px 16px', borderRadius: 10, border: 'none',
          background: input.trim() && !loading ? 'var(--color-primary,#0f5a30)' : '#e2e8f0',
          color: input.trim() && !loading ? 'white' : '#94a3b8',
          cursor: input.trim() && !loading ? 'pointer' : 'not-allowed', fontWeight: 700, fontSize: '0.85rem'
        }}>
          {loading ? '…' : '▶'}
        </button>
      </div>

      <style>{`
        @keyframes bounce {
          0%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-6px); }
        }
      `}</style>
    </div>
  );
};

// ── Constantes de configuração ──────────────────────────────────────────────

const MODELOS = [
  { value: 'claude-haiku-4-5-20251001', label: 'Claude Haiku 4.5 — rápido e econômico (recomendado)' },
  { value: 'claude-sonnet-4-6',         label: 'Claude Sonnet 4.6 — mais capaz, intermediário' },
  { value: 'claude-opus-4-7',           label: 'Claude Opus 4.7 — mais avançado' },
];

const Toggle = ({ label, description, value, onChange }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 0', borderBottom: '1px solid #f1f5f9' }}>
    <div>
      <div style={{ fontWeight: 600, fontSize: '0.875rem', color: '#1e293b' }}>{label}</div>
      {description && <div style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: 2 }}>{description}</div>}
    </div>
    <button onClick={() => onChange(!value)} style={{
      width: 46, height: 26, borderRadius: 13, border: 'none', cursor: 'pointer',
      background: value ? 'var(--color-primary,#0f5a30)' : '#cbd5e1',
      position: 'relative', transition: 'all 0.2s', flexShrink: 0
    }}>
      <span style={{
        position: 'absolute', top: 3, width: 20, height: 20, borderRadius: '50%',
        background: 'white', boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        left: value ? 23 : 3, transition: 'left 0.2s'
      }} />
    </button>
  </div>
);

export const GerenciadorBot = ({ createApi, isMobile = false }) => {
  const [config, setConfig] = useState(null);
  const [editado, setEditado] = useState({});
  const [novaKey, setNovaKey] = useState('');
  const [mostrarKey, setMostrarKey] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [toast, setToast] = useState(null);

  const showToast = useCallback((type, msg) => {
    setToast({ type, msg });
    setTimeout(() => setToast(null), 4000);
  }, []);

  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      const api = createApi();
      const res = await api.get('/admin/bot/config');
      setConfig(res.data);
      setEditado({
        ativo:             res.data.ativo,
        modelo:            res.data.modelo,
        max_tokens:        res.data.max_tokens,
        max_historico:     res.data.max_historico,
        nome_bot:          res.data.nome_bot,
        instrucoes_extras: res.data.instrucoes_extras || '',
      });
    } catch {
      showToast('error', 'Erro ao carregar configurações do bot');
    } finally {
      setCarregando(false);
    }
  }, [createApi, showToast]);

  useEffect(() => { carregar(); }, [carregar]);

  const set = (campo, valor) => setEditado(e => ({ ...e, [campo]: valor }));

  const salvar = async () => {
    setSalvando(true);
    try {
      const api = createApi();
      const payload = { ...editado };
      if (novaKey.trim()) payload.api_key = novaKey.trim();
      const res = await api.put('/admin/bot/config', payload);
      setConfig(res.data);
      setNovaKey('');
      showToast('success', res.data.message || '✅ Salvo!');
    } catch (err) {
      showToast('error', err.response?.data?.error || 'Erro ao salvar');
    } finally {
      setSalvando(false);
    }
  };

  if (carregando) return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem' }}>
      <div style={{ width: 32, height: 32, border: '3px solid #e2e8f0', borderTopColor: 'var(--color-primary,#0f5a30)', borderRadius: '50%', animation: 'spin 1s linear infinite' }} />
    </div>
  );

  const inputStyle = {
    width: '100%', padding: '9px 12px', borderRadius: 10,
    border: '1.5px solid #e2e8f0', fontSize: '0.88rem',
    outline: 'none', boxSizing: 'border-box', background: 'white'
  };

  return (
    <div style={{ fontFamily: "'Inter', sans-serif", color: '#1e293b' }}>

      {toast && (
        <div style={{
          position: 'fixed', top: 20, right: 20, zIndex: 9999,
          background: toast.type === 'success' ? '#f0fdf4' : '#fef2f2',
          border: `1px solid ${toast.type === 'success' ? '#bbf7d0' : '#fecaca'}`,
          color: toast.type === 'success' ? '#166534' : '#991b1b',
          padding: '12px 20px', borderRadius: 12, fontWeight: 600,
          boxShadow: '0 8px 24px rgba(0,0,0,0.1)', fontSize: '0.875rem'
        }}>{toast.msg}</div>
      )}

      {/* Header */}
      <div style={{ padding: isMobile ? '16px' : '20px 28px', borderBottom: '1px solid #f1f5f9', background: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: isMobile ? '1.05rem' : '1.15rem', fontWeight: 700 }}>🤖 Configurações do Bot</h2>
          <p style={{ margin: '3px 0 0', fontSize: '0.8rem', color: '#64748b' }}>Assistente virtual de agendamento integrado à IA Claude</p>
        </div>
        <button onClick={salvar} disabled={salvando} style={{
          padding: '9px 18px', borderRadius: 10, border: 'none',
          background: 'var(--color-primary,#0f5a30)', color: 'white',
          fontSize: '0.85rem', fontWeight: 700, cursor: salvando ? 'not-allowed' : 'pointer'
        }}>
          {salvando ? 'Salvando…' : '💾 Salvar'}
        </button>
      </div>

      <div style={{ padding: isMobile ? '16px' : '24px 28px', display: 'flex', flexDirection: 'column', gap: 24, maxWidth: 660 }}>

        {/* Status */}
        <div style={{ background: 'white', borderRadius: 14, border: '1px solid #e2e8f0', padding: '4px 16px' }}>
          <Toggle
            label="Bot ativo"
            description="Quando desativado, o chat retorna mensagem de indisponibilidade"
            value={editado.ativo ?? true}
            onChange={v => set('ativo', v)}
          />
        </div>

        {/* API Key */}
        <div style={{ background: '#fafbfc', borderRadius: 14, border: '1.5px solid #e2e8f0', padding: '18px 20px' }}>
          <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 4 }}>🔑 Chave de API Anthropic</div>
          {config?.api_key_configurada ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
              <span style={{ fontFamily: 'monospace', fontSize: '0.82rem', color: '#475569', background: '#f1f5f9', padding: '4px 10px', borderRadius: 8, flex: 1 }}>
                {config.api_key}
              </span>
              <span style={{ fontSize: '0.72rem', background: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0', borderRadius: 20, padding: '2px 10px', fontWeight: 700 }}>✓ Configurada</span>
            </div>
          ) : (
            <div style={{ marginBottom: 12, padding: '8px 12px', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, fontSize: '0.8rem', color: '#92400e' }}>
              ⚠️ Nenhuma chave configurada — o bot está inativo mesmo que habilitado
            </div>
          )}
          <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>
            {config?.api_key_configurada ? 'Substituir chave (deixe vazio para manter a atual)' : 'Inserir chave'}
          </label>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              type={mostrarKey ? 'text' : 'password'}
              value={novaKey}
              onChange={e => setNovaKey(e.target.value)}
              placeholder="sk-ant-api03-..."
              style={{ ...inputStyle, flex: 1 }}
            />
            <button onClick={() => setMostrarKey(v => !v)} style={{ padding: '9px 14px', borderRadius: 10, border: '1.5px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: '0.85rem' }}>
              {mostrarKey ? '🙈' : '👁️'}
            </button>
          </div>
          <div style={{ marginTop: 8, fontSize: '0.72rem', color: '#94a3b8' }}>
            A chave é armazenada no banco de dados e nunca aparece em texto no código ou no servidor.
          </div>
        </div>

        {/* Identidade */}
        <div>
          <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 10 }}>👤 Identidade do Bot</div>
          <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#475569', display: 'block', marginBottom: 6 }}>Nome do bot</label>
          <input
            type="text"
            value={editado.nome_bot || ''}
            onChange={e => set('nome_bot', e.target.value)}
            placeholder="Alma"
            style={inputStyle}
          />
          <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 4 }}>Aparece no system prompt como "Você é [nome]..."</div>
        </div>

        {/* Modelo */}
        <div>
          <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 10 }}>🧠 Modelo de IA</div>
          <select value={editado.modelo || ''} onChange={e => set('modelo', e.target.value)} style={inputStyle}>
            {MODELOS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
        </div>

        {/* Parâmetros */}
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: 16 }}>
          <div>
            <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>Max tokens por resposta</label>
            <input type="number" min={256} max={4096} step={256} value={editado.max_tokens || 1024} onChange={e => set('max_tokens', parseInt(e.target.value))} style={inputStyle} />
            <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 4 }}>Tamanho máximo de cada resposta (256–4096)</div>
          </div>
          <div>
            <label style={{ fontSize: '0.78rem', fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>Histórico de mensagens</label>
            <input type="number" min={4} max={50} value={editado.max_historico || 20} onChange={e => set('max_historico', parseInt(e.target.value))} style={inputStyle} />
            <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: 4 }}>Quantas mensagens anteriores o bot "lembra" (4–50)</div>
          </div>
        </div>

        {/* Instruções extras */}
        <div>
          <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 4 }}>📝 Instruções adicionais</div>
          <div style={{ fontSize: '0.78rem', color: '#64748b', marginBottom: 10 }}>
            Regras ou comportamentos extras que serão adicionados ao prompt do bot. Ex: horários especiais, promoções, tom de comunicação.
          </div>
          <textarea
            value={editado.instrucoes_extras || ''}
            onChange={e => set('instrucoes_extras', e.target.value)}
            rows={5}
            placeholder={'Ex: Não agende vagas de sábado após as 20h de sexta.\nSempre mencione que temos estacionamento gratuito.'}
            style={{ ...inputStyle, resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.6 }}
          />
        </div>

        {/* Info migração */}
        <div style={{ background: '#eff6ff', borderRadius: 12, padding: '14px 18px', border: '1px solid #bfdbfe', fontSize: '0.8rem', color: '#1e40af', lineHeight: 1.7 }}>
          <strong>ℹ️ Sobre a migração:</strong> A chave Anthropic agora é armazenada no banco de dados.
          Após salvar aqui, a variável <code style={{ background: '#dbeafe', padding: '1px 6px', borderRadius: 4 }}>ANTHROPIC_API_KEY</code> no <code>.env</code> pode ser removida com segurança.
          O banco tem prioridade sobre o <code>.env</code>.
        </div>

        {/* ── Área de teste ── */}
        <BotTeste createApi={createApi} nomeBot={editado.nome_bot || 'Alma'} />

      </div>
    </div>
  );
};
